import * as ApplicationConstants from './Application';
import * as IdleMonitorConstants from './IdleMonitor';

const DOMAIN_NAME = 'application' as const;

export default {
  DOMAIN_NAME,
  ApplicationConstants,
  IdleMonitorConstants,
};
